import React from 'react';
import { Auto } from 'fw/forms';
import * as API from 'modules/app/API'

class SponsorInvoiceAuto extends React.Component {

	sponsorInvoicesLoader = () => {
		return {
			url: API.App.url('/lookup/lookupSponsorInvoice'),
			params: {
				value: this.props.value,
				sponsorId: this.props.sponsorId,
				preloadMonths: this.props.preloadMonths
			}
		}
	}

	render() {
		return (
			<Auto
				{...this.props}
				key={`sponsor-invoice-${this.props.sponsorId}`}
				menuWidth="400px"
				loader={this.sponsorInvoicesLoader}
				placeholder={this.props.placeholder}
				sponsorId={this.props.sponsorId}
				minLength={0}
				defaultOptions={true}
				/>
		)
	}
}

export default SponsorInvoiceAuto;

// Mark this as a form component
SponsorInvoiceAuto.defaultProps = {
	formControl: true,
	managed: false,
	placeholder: "Search...",
	sponsorId: null,
	preloadMonths: null
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/sponsorInvoiceAuto/SponsorInvoiceAuto.js